export default "__VITE_ASSET__4w9$o2Ns__"